<div class="dialogContent">
	<!--HEADER-->
	@if (!hideHeader) {
		<header [class.headerSmall]="smallHeader" class="header mat-elevation-z2">
			<div class="headerTitle">
				<mat-icon [fontIcon]="headerIcon?.fontIcon" [fontSet]="headerIcon?.fontSet" class="headerIcon" inline />
				<label>
					{{ headerText }}
				</label>
			</div>
			<span class="headerActionsWrapper">
				<ng-content select="[headerActions]" />
			</span>
			@if (showClosingX) {
				<button (click)="closeClicked.emit()" [appFocus]="false" class="closeButton" mat-icon-button>
					<mat-icon fontIcon="fa-times" fontSet="fal" inline style="font-size: 1.5em" />
				</button>
			}
			@if (matDialogData && rect && matDialogData.align === "left") {
				<div
					[style.left]="finished ? rect.left - 15 + 'px' : rect.left - 25 + 'px'"
					[style.top]="finished ? rect.bottom - rect.height / 2 - 5 + 'px' : rect.bottom - rect.height + 5 + 'px'"
					class="dialogCaretLeft"
				></div>
			}
			@if (matDialogData && rect && matDialogData.align === "right") {
				<div
					[style.left]="finished ? rect.right + 5 + 'px' : rect.right + 25 + 'px'"
					[style.top]="finished ? rect.bottom - rect.height / 2 - 5 + 'px' : rect.bottom - rect.height + 5 + 'px'"
					class="dialogCaretRight"
				></div>
			}
			@if (matDialogData && rect && matDialogData.align === "bottom") {
				<div
					[style.left]="finished ? rect.left + 10 + 'px' : rect.right + 25 + 'px'"
					[style.top]="finished ? rect.bottom - 5 + 'px' : rect.bottom + 30 + 'px'"
					class="dialogCaretBottom"
				></div>
			}
		</header>
	}

	<!--CONTENT-->
	<div class="allContent">
		<div [class.overflowHandledByChild]="overflowHandledByChild" class="content">
			<ng-content select="[dialogContent]" />
		</div>
		@if (actionsWrapper?.childNodes?.length > 0 && showActionDivider) {
			<mat-divider class="divider" />
		}
		<div #actionsWrapper class="actions actionsWrapper">
			<ng-content class="actions" select="[actions]" />
		</div>
	</div>
</div>
